import { Button, Checkbox, Form, Input, Typography } from "antd";
import { Link } from "react-router";
import GlassPanel from "../../components/common/glassPanel";

const { Text, Title } = Typography;

export default function LoginScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-10">
      <div className="w-full max-w-md">
        <GlassPanel className="overflow-hidden" bodyClassName="p-6 sm:p-7">
          <Text className="block text-[11px]! uppercase tracking-[0.22em] text-black/45 dark:text-white/45">
            SERID Internal
          </Text>
          <Title level={2} className="mb-1! mt-3!">
            Employee sign in
          </Title>
          <Text type="secondary">
            Access the internal workspace for operations, support, and sector oversight.
          </Text>

          <Form layout="vertical" className="mt-6">
            <Form.Item label="Work email">
              <Input size="large" placeholder="name@serid.app" />
            </Form.Item>
            <Form.Item label="Password">
              <Input.Password size="large" placeholder="Password" />
            </Form.Item>
            <div className="mb-5 flex items-center justify-between gap-3">
              <Checkbox>Keep me signed in</Checkbox>
              <Link to="/accept-invite">Accept invite</Link>
            </div>
            <Button type="primary" size="large" block href="/sector/wheels/command-center">
              Continue
            </Button>
          </Form>
        </GlassPanel>
      </div>
    </div>
  );
}
